import React from 'react';

import Container from '@/components/ui/container';
import Row from '@/components/ui/row';

const Footer: React.FC = () => {
  return (
    <footer className=' bg-gray-10 py-4'>
      <Container>
        <Row>
          <div className='flex items-center justify-center'>
            <p className='text-sm text-gray-50'>
              &copy; {new Date().getFullYear()} Veggie World. All rights
              reserved.
            </p>
          </div>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
